import { formatDate } from '@thoughtspot/date-format-util';
import { useTranslation } from '@thoughtspot/i18n';
import { useMemo } from 'react';
import { getAuthTypeLabel, getStatusDisplayLabel, V2TranslationKeys, } from '../constants';
export const useUserDetails = ({ user, isClusterAdmin, orgNameMap, }) => {
    const { t } = useTranslation();
    return useMemo(() => {
        const displayName = user?.displayName ?? '';
        const email = user?.email ?? '';
        const userId = user?.id ?? '';
        const status = user?.userState ?? '';
        const created = user?.created;
        const authType = user?.type ?? '';
        const metadataRows = [
            {
                label: t(V2TranslationKeys.USER_DETAILS_STATUS),
                value: getStatusDisplayLabel(status),
            },
            {
                label: t(V2TranslationKeys.USER_DETAILS_USER_SINCE),
                value: created ? formatDate(created, 'd MMMM yyyy') : '',
            },
            {
                label: t(V2TranslationKeys.USER_DETAILS_USER_TYPE),
                value: getAuthTypeLabel(authType),
            },
        ];
        const orgIds = user?.orgIds ?? [];
        const orgNames = isClusterAdmin
            ? orgIds.map(id => orgNameMap[id]).filter(Boolean)
            : [];
        const listTitle = isClusterAdmin
            ? t(V2TranslationKeys.USER_DETAILS_ORGS)
            : t(V2TranslationKeys.USER_DETAILS_GROUPS);
        const listItems = isClusterAdmin
            ? orgNames.map(name => ({ key: name, label: name }))
            : (user?.groups ?? []).map(g => ({ key: g.id, label: g.name }));
        return {
            displayName,
            email,
            userId,
            metadataRows,
            listTitle,
            listItems,
        };
    }, [user, orgNameMap, isClusterAdmin, t]);
};
//# sourceMappingURL=useUserDetails.js.map